import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrainEvent } from '../../models/trainEvent';
import { Subscription } from 'rxjs';
import { TableStateService } from '../../../../shared/services/table-state.service';

@Component({
  selector: 'app-monitored-train-events',
  template: require('./monitored-train-events.component.html'),
  styles: [require('./monitored-train-events.component.sass')]
})
export class MonitoredTrainEventsComponent implements OnInit {

  // Component API (Input/Output)
  @Input() events: TrainEvent[];

  // Component (private) properties
  tableConfiguration: any = {
    paginate: true,
    sortableMode: 'multiple',
    defaultPagination: 250,
    itemsPerPageOptions: [50,100,250,500],
    exportFilename: 'train-events'
  }
  columns: any[];

  languageChangeSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    public tableState: TableStateService
  ) { 
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.refreshTrainEventTable();
    })
  }

  ngOnInit(): void {
    this.refreshTrainEventTable();
  }

  refreshTrainEventTable = () => {
    this.columns = [{
      header: this.translate.instant('I18N_MONITORING.TIMESTAMP'),
      field: 'timestamp',
      type: 'date'
    }, {
      header: this.translate.instant('I18N_MONITORING.TARGET'),
      field: 'target',
      type: 'text'
    }, {
      header: this.translate.instant('I18N_MONITORING.MESSAGE'),
      field: 'message',
      type: 'text',
      disableSorting: true
    }]
  }

}
